const ServiceType = {
  Recurring: 'RECURRING',
  Prepaid: 'PREPAID',
} as const;

export default ServiceType;
